module.exports = __webpack_public_path__ + "img/profile_img.eb18de5f.png";